<div class="modal-header border-0 pb-0" data-testid="switch-workspace-modal">
  <h5 class="modal-title">Switch</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  ></button>
</div>

<div class="modal-body pt-2">
  @if (loading()) {
    <div class="text-muted">Carregando contas...</div>
  } @else if (loadError()) {
    <div class="alert alert-danger mb-0">{{ loadError() }}</div>
  } @else if (!hasAccounts()) {
    <div class="alert alert-warning mb-0">
      Nenhuma conta ou workspace disponivel.
    </div>
  } @else {
    <label class="form-label" for="account-switch-select">Conta</label>
    <ng-select
      id="account-switch-select"
      class="mb-3"
      data-testid="switch-account-select"
      [items]="accounts()"
      [searchable]="true"
      [clearable]="false"
      [bindLabel]="'name'"
      [bindValue]="'id'"
      [inputAttrs]="accountSelectInputAttributes"
      [placeholder]="'Selecione uma conta'"
      [ngModel]="selectedAccountId()"
      (ngModelChange)="onAccountChange($event)"
    >
      <ng-template ng-option-tmp let-item="item">
        <div>{{ item.name }}</div>
      </ng-template>
    </ng-select>
    <label class="form-label" for="workspace-switch-select">Workspace</label>
    <ng-select
      id="workspace-switch-select"
      data-testid="switch-workspace-select"
      [items]="workspaces()"
      [searchable]="true"
      [clearable]="false"
      [bindLabel]="'name'"
      [bindValue]="'id'"
      [placeholder]="'Selecione um workspace'"
      [disabled]="selectedAccountId() === null || !hasWorkspaces()"
      [ngModel]="selectedWorkspaceId()"
      (ngModelChange)="selectedWorkspaceId.set($event)"
    >
      <ng-template ng-option-tmp let-item="item">
        <div>{{ item.name }}</div>
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        {{ item.name }}
      </ng-template>
    </ng-select>
    @if (switchError()) {
      <div class="alert alert-danger mt-3 mb-0">{{ switchError() }}</div>
    }
  }
</div>

<div class="modal-footer border-0 pt-2">
  <button
    type="button"
    class="btn btn-light"
    data-testid="switch-workspace-cancel"
    (click)="activeModal.dismiss()"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    data-testid="switch-workspace-submit"
    [disabled]="!canSwitch()"
    (click)="onSwitch()"
  >
    {{ switching() ? "Switching..." : "Switch" }}
  </button>
</div>
